import { cn } from '~/utils/cn';

import { Icon } from '../Icon/view';

interface PropsSearch {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
}

export default function Search({ value, onChange, placeholder = 'Buscar...', className }: PropsSearch) {
  return (
    <div
      className={cn(
        'flex items-center gap-nano h-[48px] px-small rounded-small bg-intense-02 border border-intense-03',
        className,
      )}
    >
      <Icon name="icon-search" size={18} color="#606060" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 bg-transparent outline-none text-bodyMD text-complement-01 placeholder:text-intense-05"
      />
      {value && (
        <Icon name="icon-close" size={18} color="#606060" onClick={() => onChange('')} />
      )}
    </div>
  );
}
